export class AttachmentFormData {
    file;
    componentType;
    description;
    jobId;
    moduleId;
    fileName;
    data;
    attachmentType;
    createdBy;
}
